import React, { useState } from 'react';
import axios from 'axios';
import {List, Box, Typography, Input, Button,TableContainer, Table, TableHead, TableBody, TableRow, Paper, Pagination,} from '@mui/material';
import { useRedirect, ResourceContextProvider } from 'react-admin';
import globalStyles from '../../utils/globalStyles'
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import legolasApi from '../../api/legolas';
import { useNavigate } from 'react-router-dom';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    borderRadius: '0px !important',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding,
    borderRadius: '0px !important'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function NewProduct() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [columnsOpen, setColumnsOpen] = React.useState(false);
  const [anchorCol, setAnchorCol] = React.useState(null);
  const [totalCount, setTotalcount] = React.useState(0);
  const [listData, setListData] = React.useState();
  const [searchString, setSearchString] = React.useState('');
  const [loading, setLoading] = useState(false);
  const [searchedItems, setSearchedItems] = React.useState([]);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [alertText, setAlertText] = React.useState('');

  const [selectedHeaders, setSelectedHeaders] = React.useState([
    { id: '_id', label: 'Ecom-ID' },
    { id: 'name', label: 'Name' }, { id: 'status', label: 'Status' },
    { id: 'type', label: 'Type' }, { id: 'sku', label: 'SKU' },
    { id: 'oracleId', label: 'oracleID' }, { id: 'quantity', label: 'Stock' },
    { id: 'rrp', label: 'Invoice Price' }, { id: 'invoicePrice', label: 'Sell Price' }
  ])
  const [openFilters, setOpenFilters] = React.useState(false)
  const [currentPage, setCurrentPage] = React.useState(1)
  const [filterArray, setFilterArray] = React.useState([])
  const [allTableHeaders, setAllTableHeaders] = React.useState([
    { id: '_id', label: 'Ecom-ID', checked: true },
    { id: 'name', label: 'Name', checked: true }, { id: 'status', label: 'Status', checked: true },
    { id: 'type', label: 'Type', checked: true }, { id: 'sku', label: 'SKU', checked: true },
    { id: 'oracleId', label: 'oracleID', checked: true }, { id: 'quantity', label: 'Stock', checked: true },
    { id: 'rrp', label: 'Invoice Price', checked: true }, { id: 'invoicePrice', label: 'Sell Price', checked: true }

  ])

  const redirect = useRedirect()
  const navigate = useNavigate()

  React.useEffect(() => {
    const fetchAll = {
      "source": "admin"
    }
    axios.get(`${legolasApi.url}/admin/products/productlist`, fetchAll).then((res) => {
      console.log('ProductList res: ', res)
      const list = res.data.data.data, count = res.data.data.count
      console.log('ProductList res:2 ', list)
      setListData(list)
      setTotalcount(count)
    }).catch((error) => console.log('Error in getting products: ', error))
      .finally(() => {
        setLoading(false);
      });
  }, [searchString === ''])


  const open = Boolean(anchorEl)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleColumnClick = (e) => {
    setColumnsOpen(true)
    setAnchorCol(e.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null);
  };


  const handleAlertGen = (msg) => {
    setAlertText(msg)
    setOpenAlert(true)
    setTimeout(() => {
      setAlertText('')
      setOpenAlert(false)
    }, 3000)
  }


  const handleSearch = () => {
    const searchQuery = searchString
    if (typeof searchQuery == 'string' && searchQuery.length > 0) {
      axios.get(`${legolasApi.url}/admin/products/productlist?search=${searchString}`).then((res) => {
        const data = res.data.data.data, count = res.data.data.count
        console.log('product res31: ', count)
        setListData(data)
        setTotalcount(count)
      })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    } else {
      console.error('Invalid search query.');
    }
  }
  const handleEditProduct = (data) => {
    // const link = `/products/editproduct`
    const link = `/products/editproduct/${data._id}`
    navigate(link, {})
  }

  function findChecked(headerId, headerArr) {
    let checked = false
    //console.log('headerId :', headerId)
    //console.log('headerArr: ', headerArr)
    for (let i = 0; i < headerArr.length; i++) {
      const checkElem = headerArr[i]
      if (checkElem['_id'] === headerId) {
        checked = true
        break
      }
    }
    return checked
  }



  function selectHeader(headerId, headerLabel, checked) {
    const headerObj = { "id": headerId, "label": headerLabel, "checked": checked }
    const totalHeaders = [...allTableHeaders]
    const foundAllHeader = totalHeaders.find(header => header.id == headerId)
    foundAllHeader.checked = checked

    setColumnsOpen(false)
    setAllTableHeaders(totalHeaders)
  }

  function resetTableHeaders() {
    const totalHeaders = [
      { id: '_id', label: 'Ecom-ID', checked: true },
      { id: 'name', label: 'Name', checked: true },
      { id: 'status', label: 'Status', checked: true },
      { id: 'type', label: 'Type', checked: true },
      { id: 'sku', label: 'SKU', checked: true },
      { id: 'oracleId', label: 'oracleID', checked: true },
      { id: 'quantity', label: 'Stock', checked: true },
      { id: 'rrp', label: 'Invoice Price', checked: true },
      { id: 'invoicePrice', label: 'Sell Price', checked: true },

    ]

    setAllTableHeaders(totalHeaders)
  }


  const handleProductCreate = () => {
    const link = `/products/addproduct`
    navigate(link, {})
  }

  const handleGridColumns = (header) => {
    selectHeader(header.id, header.label, !header.checked)
  }

  const handlePagination = (event, value) => {
    // console.log('Pagination value: ', value)
    const paginationPayload = { "source": "admin" }
    axios.get(`${legolasApi.url}/admin/products/productlist?offset=${value - 1}`, paginationPayload).then((res) => {
      // console.log('re.data', res.data)
      //const list = res.data
      setCurrentPage(value);
      setListData(res.data.data.data);
    })
  }

  function selectHeader(headerId, headerLabel) {
    const headerObj = { "id": headerId, "label": headerLabel }
    const currentSelected = selectedHeaders;
    currentSelected.push(headerObj);
    setColumnsOpen(false);
    setSelectedHeaders(currentSelected);
  }

  function extractString(data) {
    const jsonString = data;
    const jsonObject = JSON.parse(JSON.stringify(jsonString));
    const enSaValue = jsonObject['en-SA'];
    return enSaValue;
  };

  if (selectedHeaders.length == 0) {
    return null;
  } else {

    return (
      <React.Fragment>
        <ResourceContextProvider resource="products">
          <List actions={null}>
            <Box sx={globalStyles.headerWrapperBox}>
              <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
                <Typography variant='h4'>Products</Typography>
                <Typography variant='subtitle1' sx={globalStyles.headerCountSubtitle}>
                  {totalCount} record(s) found
                </Typography>
              </Box>
              <Box sx={{ width: '50%', alignItems: 'center', margin: '24px 30px' }}>
                <Button variant="contained" sx={globalStyles.createButton} onClick={() => handleProductCreate()}>
                  Create Product
                </Button>
              </Box>
            </Box>

            <Box sx={globalStyles.headerWrapperBox}>
              <Box sx={{
                width: '100%',
                display: 'flex',
                margin: '0px 30px',
                '& .MuiInput-input': {
                  width: '300px !important',
                  padding: '5px 10px !important'
                },
                '& .MuiSvgIcon-root': {
                  paddingRight: '10px'
                },
                justifyContent: 'space-between'
              }}>
                <Input
                  type='search'
                  sx={{ border: '1px solid #2b3f7a', borderRadius: '20px' }}
                  endAdornment={<SearchIcon sx={{ cursor: 'pointer' }} onClick={() => handleSearch()} />}
                  placeholder='Seach by  keywords'
                  onChange={(e) => setSearchString(e.target.value)}
                />

                <Box sx={{
                  width: '43vw',
                  justifyContent: 'end',
                  textAlign: 'end',
                  '& .MuiButton-sizeSmall': {
                    lineHeight: '30px !important'
                  },
                  '& .MuiDivider-root': {
                    borderRightWidth: 'thin !important',
                    borderColor: '#2b3f7a'
                  }
                }}>
                </Box>
              </Box>
            </Box>
            <Box>

              <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
                <Table aria-label="simple table">
                  <TableHead sx={{
                    backgroundColor: globalStyles.colors.backgroundPrimary,
                    height: '40px !important',
                    borderRadius: '0 !important',
                    '& .MuiTableCell-root': {
                      color: '#fff !important',
                      padding: '10px !important',
                      borderRight: '-3px solid #fff !important',
                      borderRadius: '0 !important'
                    }
                  }}>
                    <TableRow>
                      {allTableHeaders.map((header) => {
                        if (header.checked) {
                          return (
                            <StyledTableCell align='center'>{header.label}</StyledTableCell>
                          )
                        }
                      })}
                    <StyledTableCell align='center'>Action</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {listData?.map((data, key) => {
                      return (
                        <StyledTableRow id={key} key={data._id}>

                          <StyledTableCell align='center'>{data._id}</StyledTableCell>
                          <StyledTableCell align='left'>{extractString(data.system.name)}</StyledTableCell>
                          <StyledTableCell align='center'>{data.system.status === true ? "Enabled" : "Disabled"}</StyledTableCell>
                          <StyledTableCell align='center'>{data.system.type}</StyledTableCell>
                          <StyledTableCell align='center'>{data.system.sku}</StyledTableCell>
                          <StyledTableCell align='center'>{data.system.oracleId}</StyledTableCell>
                          <StyledTableCell align='center'>{data.stock.quantity > 0 ? "in Stock" : "out of Stock"}</StyledTableCell>
                          <StyledTableCell align='center'>{data.price?.prc.rrp}</StyledTableCell>
                          <StyledTableCell align='center'>{data.price?.price.invoicePrice}</StyledTableCell>
                          <StyledTableCell align='center'>
                          <Button onClick={() => handleEditProduct(data) }>VIEW</Button></StyledTableCell>
                          </StyledTableRow>
                      )

                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box sx={{ justifyContent: 'center' }}>
              <Pagination count={Math.ceil(totalCount / 20)} page={currentPage} onChange={handlePagination} />
            </Box>
          </List>
        </ResourceContextProvider>
      </React.Fragment>
    )

  }
}

export default NewProduct;